/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LadderChallenge } from './LadderChallenge';
import {
    LadderChallengeFromJSON,
    LadderChallengeFromJSONTyped,
    LadderChallengeToJSON,
    LadderChallengeToJSONTyped,
} from './LadderChallenge';

/**
 * 
 * @export
 * @interface CreateLadderChallengeResponse
 */
export interface CreateLadderChallengeResponse {
    /**
     * 
     * @type {LadderChallenge}
     * @memberof CreateLadderChallengeResponse
     */
    challenge: LadderChallenge;
}

/**
 * Check if a given object implements the CreateLadderChallengeResponse interface.
 */
export function instanceOfCreateLadderChallengeResponse(value: object): value is CreateLadderChallengeResponse {
    if (!('challenge' in value) || value['challenge'] === undefined) return false;
    return true;
}

export function CreateLadderChallengeResponseFromJSON(json: any): CreateLadderChallengeResponse {
    return CreateLadderChallengeResponseFromJSONTyped(json, false);
}

export function CreateLadderChallengeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLadderChallengeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge': LadderChallengeFromJSON(json['challenge']),
    };
}

export function CreateLadderChallengeResponseToJSON(json: any): CreateLadderChallengeResponse {
    return CreateLadderChallengeResponseToJSONTyped(json, false);
}

export function CreateLadderChallengeResponseToJSONTyped(value?: CreateLadderChallengeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge': LadderChallengeToJSON(value['challenge']),
    };
}

